import React, { FC } from 'react'
import './index.scss'

interface IProps {
  selected: any;
  list: any[];
  onChange: (val: string) => void;
}

const CateTab: FC<IProps> = (props: IProps) => {
  const { list, selected, onChange } = props
  return (
    <div className='mkt-category-tab'>
      {
        list.map((item: any) => {
          return item && (
            <div
              data-cypid='mmgChangeCateTab'
              key={item.value}
              className={`detail-cate-item ${item.value === selected && 'detail-cate-item-ed'}`}
              onClick={() => { onChange(item.value) }}
            >{item.label}
            </div>)
        })
      }
    </div>
  )
}
export default CateTab
